import { render, staticRenderFns } from "./PendingScreensHome.vue?vue&type=template&id=f4000984&"
import script from "./PendingScreensHome.vue?vue&type=script&lang=ts&"
export * from "./PendingScreensHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports